export default __webpack_public_path__ + "static/media/forza-motorsport-7.e61028b0.png";